export const isTechnicalUrl = (technicalUrl) => window.location.pathname.endsWith(technicalUrl);
